// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-popover{background:#fff!important;border:none!important;border-radius:.12rem!important;box-shadow:0 .04rem .12rem 0 rgba(0,0,0,.1)!important;box-sizing:border-box!important;height:5.2rem!important;padding:0!important;width:3.6rem!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
